<template>
  <teleport to="body">
    <div
      :class="['feiyu-popup', `feiyu-popup--position-${position}`, $attrs.class]"
      :style="{ zIndex: String(zIndex) }"
    >
      <transition :appear="true" name="feiyu-popup--overlay">
        <div
          v-show="show && overlay"
          :class="['feiyu-popup--overlay', overlayClass]"
          :style="{ zIndex: String(zIndex + 100) }"
          @click="onOverlayClick"
        />
      </transition>
      <transition
        :appear="true"
        :name="`feiyu-popup--position-${position}`"
        @after-leave="onAfterLeave"
      >
        <div
          v-show="show"
          :class="['feiyu-popup--content', contentClass]"
          :style="{
            zIndex: String(zIndex + 1000),
            width: typeof width === 'string' ? width : `${width}px`,
            height: typeof height === 'string' ? height : `${height}px`,
            maxWidth: typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`,
            maxHeight: typeof maxHeight === 'string' ? maxHeight : `${maxHeight}px`,
          }"
        >
          <slot />
        </div>
      </transition>
    </div>
  </teleport>
</template>

<script>
const state = {
  zIndex: 100000,
};

export default {
  inheritAttrs: false,
  emits: ["update:visible"],
  data() {
    return {
      show: false,
      zIndex: -1,
    };
  },
  props: {
    visible: { type: Boolean, default: false },
    position: { type: String, default: "center" },
    overlay: { type: Boolean, default: true },
    width: { type: [String, Number], default: "auto" },
    height: { type: [String, Number], default: "auto" },
    maxWidth: { type: [String, Number], default: "100%" },
    maxHeight: { type: [String, Number], default: "100%" },
    overlayClass: { type: [String, Array, Object], default: "" },
    contentClass: { type: [String, Array, Object], default: "" },
    closeOnOverlayClick: { type: Boolean, default: false },
  },
  methods: {
    onOverlayClick() {
      if (!this.closeOnOverlayClick) return;
      this.$emit("update:visible", false);
    },
    onAfterLeave() {
      this.show = false;
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler() {
        this.show = this.visible;
        if (this.visible) return;
        state.zIndex += 1000;
        this.zIndex = state.zIndex;
      },
    },
  },
};
</script>

<style lang="less">
.feiyu-popup {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  pointer-events: none;
}

.feiyu-popup--overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: auto;

  &-enter-active,
  &-leave-active {
    transition: opacity 0.25s;
  }

  &-enter-from,
  &-leave-to {
    opacity: 0%;
  }
}

.feiyu-popup--content {
  position: relative;
  overflow: auto;
  pointer-events: auto;
}

.feiyu-popup--position-center {
  justify-content: center;
  align-items: center;

  &-enter-active {
    transition: opacity 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  &-leave-active {
    transition: opacity 0.2s linear;
  }

  &-enter-from,
  &-leave-to {
    opacity: 0%;
  }
}

.feiyu-popup--position-top {
  flex-direction: column;
  justify-content: flex-start;

  &-enter-active,
  &-leave-active {
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &-enter-from,
  &-leave-to {
    transform: translate3d(0, -100%, 0);
  }
}

.feiyu-popup--position-bottom {
  flex-direction: column;
  justify-content: flex-end;

  &-enter-active,
  &-leave-active {
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &-enter-from,
  &-leave-to {
    transform: translate3d(0, 100%, 0);
  }
}

.feiyu-popup--position-right {
  justify-content: flex-end;

  .feiyu-popup--content {
    height: 100%;
  }

  &-enter-active,
  &-leave-active {
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &-enter-from,
  &-leave-to {
    transform: translate3d(100%, 0, 0);
  }
}

.feiyu-popup--position-left {
  justify-content: flex-start;

  &-enter-active,
  &-leave-active {
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &-enter-from,
  &-leave-to {
    transform: translate3d(-100%, 0, 0);
  }
}
</style>
